import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from 'react';
const ThemeContext = createContext(undefined);
export function ThemeProvider({ defaultTheme = 'dark', storageKey = 'pipebase:theme', children, }) {
    const [theme, setThemeState] = useState(() => {
        if (typeof localStorage === 'undefined')
            return defaultTheme;
        const stored = localStorage.getItem(storageKey);
        return stored === 'light' || stored === 'dark' ? stored : defaultTheme;
    });
    useEffect(() => {
        document.documentElement.dataset.theme = theme;
        if (typeof localStorage !== 'undefined') {
            localStorage.setItem(storageKey, theme);
        }
    }, [theme, storageKey]);
    const setTheme = (t) => setThemeState(t);
    return (_jsx(ThemeContext.Provider, { value: { theme, setTheme }, children: children }));
}
export function useTheme() {
    const ctx = useContext(ThemeContext);
    if (!ctx)
        throw new Error('useTheme must be used inside <ThemeProvider>');
    return ctx;
}
//# sourceMappingURL=ThemeProvider.js.map